import request from '@/utils/request'

export function getBoardCounts(data: any) {
  return request({
    url: `iot/device-instance/${data}/device-statistics`,
    method: 'GET',
    // data,
  })
}
